import { render, staticRenderFns } from "./BuildPresets.vue?vue&type=template&id=345fc970&scoped=true"
import script from "./BuildPresets.vue?vue&type=script&lang=js"
export * from "./BuildPresets.vue?vue&type=script&lang=js"
import style0 from "./BuildPresets.vue?vue&type=style&index=0&id=345fc970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345fc970",
  null
  
)

export default component.exports